export const HEADER_COLUMNS = ["_id","tr_style","td_first_style","td_second_style","columns_name","order_id",
    "end_of_business_name","alias_column_name","adddollarsign"];